<div class="resume">
    <div class="resume-header">
        <div class="icon-wrapper">
            <i data-feather="shopping-cart"></i>
        </div>
        <h2>Resumen del pedido</h2>
    </div>

    <!-- Resume Products -->
    <div class="resume-content">
        <div class="product-item" *ngFor="let item of cart">
            <div class="product-image">
                <img *ngIf="item.product.photo_feature == '' || item.product.photo_feature == undefined" src="/assets/img/products/product-04.webp" [alt]="item.product.title" />
                <img *ngIf="item.product.photo_feature != '' && item.product.photo_feature != undefined" [src]="item.product.photo_feature" [alt]="item.product.title" />
            </div>

            <div class="product-details">
                <h3 class="product-title">{{ item.product.title }}</h3>
                
                <div class="product-pricing">
                    <div class="quantity-price">
                        <span class="quantity">{{ item.quantity }} x</span>
                        <span class="current-price">{{ getPrice(item.product) | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                    </div>
                    
                    <div class="discount-info" *ngIf="getDiscount(item.product) != ''">
                        <span class="original-price">{{ getPriceWithoutDiscount(item.product) | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                        <span class="discount-badge">{{ getDiscount(item.product) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Resumen Price -->
    <div class="resume-summary">
        <div class="summary-item">
            <span class="label">Subtotal</span>
            <span class="value">{{ transaction.subtotal | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
        </div>
        
        <div class="summary-item">
            <span class="label">Cargos adicionales</span>
            <span class="value">{{ getAdditionalProcessed() | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
        </div>
        
        <div class="summary-item" *ngIf="getDiscountProcessed() > 0">
            <span class="label">Descuentos en productos</span>
            <span class="value discount">- {{ getDiscountProcessed() | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
        </div>
        
        <div class="summary-item coupon-discount-item" *ngIf="couponApplied">
            <span class="label">
                <i data-feather="tag"></i>
                Cupón: {{ couponCode }}
            </span>
            <span class="value discount">- {{ couponAmount | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
        </div>
        
        <!-- Coupon Section -->
        <div class="coupon-section" *ngIf="!couponApplied">
            <div class="coupon-input-group">
                <input 
                    type="text" 
                    [(ngModel)]="couponCode" 
                    placeholder="¿Tenés un cupón?"
                    class="coupon-input"
                    [disabled]="couponLoading"
                    (keyup.enter)="applyCoupon()"
                    maxlength="10"
                />
                <button 
                    (click)="applyCoupon()" 
                    class="btn-apply-coupon"
                    [disabled]="couponLoading || !couponCode"
                >
                    <span *ngIf="!couponLoading">Aplicar</span>
                    <span *ngIf="couponLoading">
                        <i data-feather="loader" class="spinning"></i>
                    </span>
                </button>
            </div>
        </div>
        
        <div class="coupon-applied-notice" *ngIf="couponApplied">
            <div class="coupon-success">
                <i data-feather="check-circle"></i>
                <span>Cupón aplicado correctamente</span>
            </div>
            <button (click)="removeCoupon()" class="btn-remove-coupon-link">
                Quitar cupón
            </button>
        </div>
        
        <div class="divider"></div>
        
        <div class="summary-total">
            <span class="total-label">Total</span>
            <span class="total-value">{{ getFinalTotal() | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
        </div>
    </div>
</div>
